var styles = {"article":"ButtonBoxDouble-module_article__WA6ss","cell":"ButtonBoxDouble-module_cell__Z8l-p","type-half":"ButtonBoxDouble-module_type-half__N1Cla","type-46":"ButtonBoxDouble-module_type-46__pCeD-","size-max":"ButtonBoxDouble-module_size-max__vB6BI"};

export { styles as default };
